import { render, staticRenderFns } from "./InsureTables.vue?vue&type=template&id=43c5d542&scoped=true&"
import script from "./InsureTables.vue?vue&type=script&lang=js&"
export * from "./InsureTables.vue?vue&type=script&lang=js&"
import style0 from "./InsureTables.vue?vue&type=style&index=0&id=43c5d542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c5d542",
  null
  
)

export default component.exports